import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=68515ff6"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports